/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "venddwrsqrayhswkbfqn"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZlbmRkd3JzcXJheWhzd2tiZnFuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEyMjIyMjYsImV4cCI6MjA4Njc5ODIyNn0.eD3q-F3t9q5xZ9ucpNMh7coiZkKrUfzn9LOJUhNX-AM"